import React from "react"
import { SidebarMenuItem } from "./SidebarMenuItem"
import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub"
import { useAuth } from "../../../AppContext"
import {
     ROUTING_ABSOLUTE_PATH_GESTION_ASSURANCES_LISTING,
     ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DDC_LISTING,
     ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_VOYANTS,
     ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_MALADIES_LISTING,
     ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_DDC_LISTING,
     ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_DECLARATIONS_VOYANTS,
     ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_MALADIES_LISTING,
     ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_ORGANIGRAMME,
     ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF,
     ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF_CREATE,
     ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE,
     ROUTING_ABSOLUTE_PATH_GESTION_BASE_DOCUMENTAIRE_DOCUMENTS_EMBAUCHE,
} from "../../../modules/gestion/routing/routing-endpoints"
import { ROUTING_ABSOLUTE_PATH_FOURNISSEUR_CREATE, ROUTING_ABSOLUTE_PATH_FOURNISSEUR_LISTING } from "../../../modules/fournisseur/routing/routing-endpoints"
import {
     CONST_USER_PERMISSION_ADMINISTRATION_ASSURANCES_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_ARRETS_MALADIE_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_BL_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DDC_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DECLARATIONS_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_ARRETS_MALADIE_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DDC_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DECLARATIONS_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_RESTRICTED,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_MANAGER,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_ADD_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_VIEW,
     CONST_USER_ROLE_SUPER_ADMIN,
     CONST_USER_ROLE_IT,
     CONST_USER_PERMISSION_AI_USAGE_VIEW,
     CONST_USER_PERMISSION_BUSINESS_COLLAB_VIEW,
     CONST_USER_PERMISSION_BUSINESS_FOURNISSEUR_VIEW,
     CONST_USER_PERMISSION_BUSINESS_PTF_VIEW,
     CONST_USER_PERMISSION_BUSINESS_VIEW,
     CONST_USER_PERMISSION_DECLARATIONS_VIEW,
     CONST_USER_PERMISSION_RECRUTEMENT_ANNONCES_VIEW,
     CONST_USER_PERMISSION_RECRUTEMENT_CANDIDATS_VIEW,
     CONST_USER_PERMISSION_RECRUTEMENT_DEMANDE_EMBAUCHE_VIEW,
     CONST_USER_PERMISSION_RECRUTEMENT_VIEW,
     CONST_USER_PERMISSION_RECRUTEMENT_VIVIERS_VIEW,
     CONST_USER_PERMISSION_RESSOURCES_BIBLIOTHEQUE_VIEW,
     CONST_USER_PERMISSION_RESSOURCES_DOCUMENTS_EMBAUCHE_VIEW,
     CONST_USER_PERMISSION_RESSOURCES_VIEW,
     CONST_USER_PERMISSION_TDB_VIEW,
} from "@common-constants/*"

// Helper for a cleaner section separator
const MenuSeparator = ({ label }: { label?: string }) => (
     <div className="menu-item pt-5">
          <div className="menu-content">
               <span className="menu-heading fw-bold text-uppercase fs-7">{label}</span>
          </div>
     </div>
)

const SidebarMenuMain = () => {
     const { currentUser } = useAuth()

     return (
          <>
               {/* 1. PERSONAL AREA - Primary Access */}
               {currentUser?.permissions?.includes(CONST_USER_PERMISSION_TDB_VIEW) && <SidebarMenuItem to="/dashboard" fontIcon={"fas fa-home"} title={"Tableau de bord"} />}

               <SidebarMenuItemWithSub title={"Mon Espace"} to={"#"} fontIcon={"fas fa-user-circle"}>
                    <SidebarMenuItem to="/personnel/mon-compte/profil" fontIcon={"fas fa-user"} title={"Mon profil"} />
                    {currentUser?.permissions?.includes(CONST_USER_PERMISSION_DECLARATIONS_VIEW) && (
                         <>
                              <SidebarMenuItem to="personnel/mes-activites/declarations" title={"Mes déclarations"} fontIcon={"fas fa-list-check"} />
                              <SidebarMenuItem to="personnel/mes-activites/ddc" fontIcon={"fas fa-umbrella-beach"} title={"Mes congés"} />
                              <SidebarMenuItem to="personnel/mes-activites/maladies" fontIcon={"fas fa-file-medical"} title={"Mes arrêts"} />
                              <SidebarMenuItem to="personnel/mes-activites/ndf" fontIcon={"fas fa-file-invoice-dollar"} title={"Mes frais"} />
                         </>
                    )}
               </SidebarMenuItemWithSub>

               {currentUser?.permissions?.includes(CONST_USER_PERMISSION_AI_USAGE_VIEW) && (
                    <SidebarMenuItem to="/ai/inspection" fontIcon={"fas fa-robot"} title={"Suivi Conso. IA"} />
               )}

               {/* 2. RECRUITMENT SECTION */}
               {currentUser?.permissions?.includes(CONST_USER_PERMISSION_RECRUTEMENT_VIEW) && (
                    <>
                         <MenuSeparator label="Recrutement" />

                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_RECRUTEMENT_ANNONCES_VIEW) && (
                              <SidebarMenuItemWithSub title={"Annonces"} to="/recrutement/annonces" fontIcon={"fas fa-bullhorn"}>
                                   <SidebarMenuItem to="/recrutement/annonces/listing" hasBullet title={"Listing"} />
                                   <SidebarMenuItem to="/recrutement/annonces/create" hasBullet title={"Diffuser"} />
                              </SidebarMenuItemWithSub>
                         )}

                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_RECRUTEMENT_CANDIDATS_VIEW) && (
                              <SidebarMenuItemWithSub title={"Candidats"} to={"recrutement/candidats"} fontIcon={"fas fa-users-viewfinder"}>
                                   <SidebarMenuItem to="/recrutement/candidats/search" hasBullet title={"Recherche"} />
                                   <SidebarMenuItem to="/recrutement/candidats/import" hasBullet title={"Ajouter"} />
                              </SidebarMenuItemWithSub>
                         )}

                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_RECRUTEMENT_VIVIERS_VIEW) && (
                              <SidebarMenuItemWithSub title={"Viviers"} to="/recrutement/viviers" fontIcon={"fas fa-layer-group"}>
                                   <SidebarMenuItem to="/recrutement/viviers/listing" hasBullet title={"Listing"} />
                                   <SidebarMenuItem to="/recrutement/viviers/create" hasBullet title={"Ajouter"} />
                              </SidebarMenuItemWithSub>
                         )}

                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_RECRUTEMENT_DEMANDE_EMBAUCHE_VIEW) && (
                              <SidebarMenuItemWithSub to="#" title={"Demandes d'embauche"} fontIcon={"fas fa-user-plus"}>
                                   <SidebarMenuItem to={"recrutement/demandes-embauche/listing"} title={"Liste"} hasBullet />
                                   <SidebarMenuItem to={"recrutement/demandes-embauche/start"} title={"Créer"} hasBullet />
                              </SidebarMenuItemWithSub>
                         )}
                    </>
               )}

               {/* 3. BUSINESS / CRM SECTION */}
               {currentUser?.permissions?.includes(CONST_USER_PERMISSION_BUSINESS_VIEW) && (
                    <>
                         <MenuSeparator label="Business & Tiers" />

                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_BUSINESS_PTF_VIEW) && (
                              <SidebarMenuItemWithSub title={"PTF"} to="/client/ptf" fontIcon={"fas fa-briefcase"}>
                                   <SidebarMenuItem to="/client/ptf/create" hasBullet title={"Ajouter"} />
                                   <SidebarMenuItem to="/client/ptf/listing" hasBullet title={"Listing"} />
                              </SidebarMenuItemWithSub>
                         )}

                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_BUSINESS_COLLAB_VIEW) && (
                              <SidebarMenuItemWithSub title={"Consultants"} to="/business/consultants" fontIcon={"fas fa-user-astronaut"}>
                                   <SidebarMenuItem to="/business/consultants/listing" hasBullet title={"Mon périmètre"} />
                                   <SidebarMenuItem to="/business/consultants/suivis" hasBullet title={"Historiques"} />
                              </SidebarMenuItemWithSub>
                         )}

                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_BUSINESS_FOURNISSEUR_VIEW) && (
                              <SidebarMenuItemWithSub title={"Fournisseurs"} to="/fournisseur" fontIcon={"fas fa-truck-fast"}>
                                   <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_FOURNISSEUR_LISTING} hasBullet title={"Listing"} />
                                   <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_FOURNISSEUR_CREATE} hasBullet title={"Ajouter"} />
                              </SidebarMenuItemWithSub>
                         )}
                    </>
               )}

               {/* 4. MANAGEMENT (GESTION) */}
               {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_VIEW) && (
                    <>
                         <MenuSeparator label="Administration" />

                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_VIEW) && (
                              <SidebarMenuItemWithSub title={"Production"} to="#" fontIcon={"fas fa-industry"}>
                                   {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DECLARATIONS_VIEW) && (
                                        <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_VOYANTS} hasBullet title={"Déclarations"} />
                                   )}
                                   {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DDC_VIEW) && (
                                        <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DDC_LISTING} hasBullet title={"Congés"} />
                                   )}
                                   {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_ARRETS_MALADIE_VIEW) && (
                                        <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_MALADIES_LISTING} hasBullet title={"Arrêts maladie"} />
                                   )}
                                   {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_BL_VIEW) && (
                                        <SidebarMenuItem to="/client/bl/dashboard" hasBullet title={"Bons de livraison"} />
                                   )}
                              </SidebarMenuItemWithSub>
                         )}

                         {/* Seuls le siège + direction + app admin */}
                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_VIEW) && (
                              <SidebarMenuItemWithSub title={"Structure & RH"} to="#" fontIcon={"fas fa-sitemap"}>
                                   {(currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW) ||
                                        currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_RESTRICTED) ||
                                        currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_MANAGER)) && (
                                        <>
                                             <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF} hasBullet title={"Liste du personnel"} />
                                             <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_ORGANIGRAMME} hasBullet title={"Organigramme"} />
                                             {/* Ajouter collaborateur : capacité dédiée, cumulable avec l'un des 3 niveaux d'accès staff */}
                                             {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_ADD_VIEW) && (
                                                  <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF_CREATE} hasBullet title={"Ajouter collaborateur"} />
                                             )}
                                             <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE} hasBullet title={"Demandes d'embauche"} />
                                             <div className="separator my-2 opacity-50"></div>
                                        </>
                                   )}
                                   {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DECLARATIONS_VIEW) && (
                                        <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_DECLARATIONS_VOYANTS} hasBullet title={"Déclarations structure"} />
                                   )}
                                   {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DDC_VIEW) && (
                                        <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_DDC_LISTING} hasBullet title={"Validations Congés"} />
                                   )}
                                   {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_ARRETS_MALADIE_VIEW) && (
                                        <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_MALADIES_LISTING} hasBullet title={"Suivi Arrêts"} />
                                   )}
                              </SidebarMenuItemWithSub>
                         )}

                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_ADMINISTRATION_ASSURANCES_VIEW) && (
                              <SidebarMenuItem title={"Assurances"} to={ROUTING_ABSOLUTE_PATH_GESTION_ASSURANCES_LISTING} fontIcon={"fas fa-shield-alt"}></SidebarMenuItem>
                         )}
                    </>
               )}

               {/* Tâches post-archive — réservé à ROLE_SUPER_ADMIN / ROLE_IT */}
               {(currentUser?.roles?.includes(CONST_USER_ROLE_SUPER_ADMIN) || currentUser?.roles?.includes(CONST_USER_ROLE_IT)) && (
                    <SidebarMenuItem to="/personnel/taches-post-archive" fontIcon={"fas fa-clipboard-check"} title={"Tâches post-archive"} />
               )}

               {/* 5. BASE DOCUMENTAIRE */}
               {((currentUser?.permissions?.includes(CONST_USER_PERMISSION_RESSOURCES_VIEW) &&
                    currentUser?.permissions?.includes(CONST_USER_PERMISSION_RESSOURCES_BIBLIOTHEQUE_VIEW)) ||
                    currentUser?.permissions?.includes(CONST_USER_PERMISSION_RESSOURCES_DOCUMENTS_EMBAUCHE_VIEW)) && (
                    <>
                         <MenuSeparator label="Base Documentaire" />

                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_RESSOURCES_DOCUMENTS_EMBAUCHE_VIEW) && (
                              <SidebarMenuItem to={ROUTING_ABSOLUTE_PATH_GESTION_BASE_DOCUMENTAIRE_DOCUMENTS_EMBAUCHE} fontIcon={"fas fa-file-signature"} title={"Documents d'embauche"} />
                         )}
                         {currentUser?.permissions?.includes(CONST_USER_PERMISSION_RESSOURCES_VIEW) &&
                              currentUser?.permissions?.includes(CONST_USER_PERMISSION_RESSOURCES_BIBLIOTHEQUE_VIEW) && (
                                   <>
                                        <SidebarMenuItem to="https://drive.google.com/drive/folders/1lZ1saimlvmZfkkV2M4IDx7jBpsqlj0bQ" fontIcon={"fas fa-award"} title={"Qualité"} target={"_blank"} />
                                        <SidebarMenuItem
                                             to="https://drive.google.com/drive/folders/1ZB4iJQgiIwirgaflXpLWiTURp_-xS1XD"
                                             fontIcon={"fas fa-bullhorn"}
                                             title={"Communication"}
                                             target={"_blank"}
                                        />
                                   </>
                              )}
                    </>
               )}
          </>
     )
}

export { SidebarMenuMain }
